query Me {
    me {
        id
        reference
        role {
            _id
            name
            actions
        }
        scope {
            client
            campaign
            campaignOnlyClient
        }
    }
}
